function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Symbols",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  fill: "#000000",
  fillRule: "nonzero",
  opacity: 0,
  x: 0,
  y: 0,
  width: 24,
  height: 24
}), /*#__PURE__*/React.createElement("path", {
  d: "M21,16 L18,16 L18,8.56 C18,7.14615104 16.853849,6 15.44,6 L8,6 L8,3 C8,2.44771525 7.55228475,2 7,2 C6.44771525,2 6,2.44771525 6,3 L6,6 L3,6 C2.44771525,6 2,6.44771525 2,7 C2,7.55228475 2.44771525,8 3,8 L6,8 L6,15.44 C6,16.853849 7.14615104,18 8.56,18 L16,18 L16,21 C16,21.5522847 16.4477153,22 17,22 C17.5522847,22 18,21.5522847 18,21 L18,18 L21,18 C21.5522847,18 22,17.5522847 22,17 C22,16.4477153 21.5522847,16 21,16 Z M8.56,16 C8.25072054,16 8,15.7492795 8,15.44 L8,8 L15.44,8 C15.7492795,8 16,8.25072054 16,8.56 L16,16 L8.56,16 Z",
  id: "Shape",
  fill: "#000000",
  fillRule: "nonzero"
})));

function SvgIconCrop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCrop);
export default __webpack_public_path__ + "static/media/icon_crop.24d4ed90.svg";
export { ForwardRef as ReactComponent };